/**
 * Collection Redirects Handler
 * Maneja redireccionamientos de colecciones a URLs con filtros
 * Los redireccionamientos nativos de Shopify no soportan query parameters
 */

// Ejecutar inmediatamente, antes de que se cargue el DOM
(function() {
  'use strict';
  
  // Mapa de redireccionamientos
  const redirects = {
    // Redireccionamientos 360°
    '/collections/360-bioetanol': '/collections/all?filter.p.m.custom.tipo_de_combustible=Bioetanol&filter.p.m.custom.vision_de_fuego=360%C2%BA',
    '/collections/360-lena': '/collections/all?filter.p.m.custom.tipo_de_combustible=Le%C3%B1a&filter.p.m.custom.vision_de_fuego=360%C2%BA',
    '/collections/360-vapordeagua': '/collections/all?filter.p.m.custom.tipo_de_combustible=Vapor+de+Agua&filter.p.m.custom.vision_de_fuego=360%C2%BA',
    
    // Redireccionamientos Frontales
    '/collections/frontal-pelletlena': '/collections/all?filter.p.m.custom.tipo_de_combustible=Le%C3%B1a&filter.p.m.custom.tipo_de_combustible=Pellet&filter.p.m.custom.vision_de_fuego=Frontal',
    '/collections/frontal-vapordeagua': '/collections/all?filter.p.m.custom.tipo_de_combustible=Vapor+de+Agua&filter.p.m.custom.vision_de_fuego=Frontal',
    '/collections/frontal-bioetanol': '/collections/all?filter.p.m.custom.tipo_de_combustible=Bioetanol&filter.p.m.custom.vision_de_fuego=Frontal',
    '/collections/frontal-electrico': '/collections/all?filter.p.m.custom.tipo_de_combustible=El%C3%A9ctrico&filter.p.m.custom.vision_de_fuego=Frontal',
    '/collections/frontal-gas': '/collections/all?filter.p.m.custom.tipo_de_combustible=Gas&filter.p.m.custom.vision_de_fuego=Frontal',
    '/collections/frontal-pellet': '/collections/all?filter.p.m.custom.tipo_de_combustible=Pellet&filter.p.m.custom.vision_de_fuego=Frontal',
    '/collections/frontal-lena': '/collections/all?filter.p.m.custom.tipo_de_combustible=Le%C3%B1a&filter.p.m.custom.vision_de_fuego=Frontal',
    
    // Redireccionamientos Dos Caras
    '/collections/doscaras-lena': '/collections/all?filter.p.m.custom.tipo_de_combustible=Le%C3%B1a&filter.p.m.custom.vision_de_fuego=Dos+caras',
    '/collections/doscaras-gas': '/collections/all?filter.p.m.custom.tipo_de_combustible=Gas&filter.p.m.custom.vision_de_fuego=Dos+caras',
    '/collections/2caras-electrico': '/collections/all?filter.p.m.custom.tipo_de_combustible=El%C3%A9ctrico&filter.p.m.custom.vision_de_fuego=Dos+caras',
    '/collections/doscaras-bioetanol': '/collections/all?filter.p.m.custom.tipo_de_combustible=Bioetanol&filter.p.m.custom.vision_de_fuego=Dos+caras',
    '/collections/doscaras-vapordeagua':  '/collections/all?filter.p.m.custom.tipo_de_combustible=Vapor+de+Agua&filter.p.m.custom.vision_de_fuego=Dos+caras',
    
    // Redireccionamientos 3 Caras
    '/collections/3caras-lena': '/collections/all?filter.p.m.custom.tipo_de_combustible=Le%C3%B1a&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+C',
    '/collections/3caras-gas': '/collections/all?filter.p.m.custom.tipo_de_combustible=Gas&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+C',
    '/collections/3caras-electrico': '/collections/all?filter.p.m.custom.tipo_de_combustible=El%C3%A9ctrico&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+C',
    '/collections/3caras-bioetanol': '/collections/all?filter.p.m.custom.tipo_de_combustible=Bioetanol&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+C',
    '/collections/3caras-vapordeagua': '/collections/all?filter.p.m.custom.tipo_de_combustible=Vapor+de+Agua&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+C',
    
    // Redireccionamientos Doble Cara
    '/collections/doblecara-lena': '/collections/all?filter.p.m.custom.tipo_de_combustible=Le%C3%B1a&filter.p.m.custom.vision_de_fuego=Doble+cara',
    '/collections/doblecara-gas': '/collections/all?filter.p.m.custom.tipo_de_combustible=Gas&filter.p.m.custom.vision_de_fuego=Doble+cara',
    '/collections/doblecara-bioetanol': '/collections/all?filter.p.m.custom.tipo_de_combustible=Bioetanol&filter.p.m.custom.vision_de_fuego=Doble+cara',
    '/collections/doblecara-electrico': '/collections/all?filter.p.m.custom.tipo_de_combustible=El%C3%A9ctrico&filter.p.m.custom.vision_de_fuego=Doble+cara',
    
    // Redireccionamientos Divisor (3 caras en forma de U)
    '/collections/divisor-lena': '/collections/all?filter.p.m.custom.tipo_de_combustible=Le%C3%B1a&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+U',
    '/collections/divisor-gas': '/collections/all?filter.p.m.custom.tipo_de_combustible=Gas&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+U',
    '/collections/divisor-bioetanol': '/collections/all?filter.p.m.custom.tipo_de_combustible=Bioetanol&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+U',
    '/collections/divisor-electrico': '/collections/all?filter.p.m.custom.tipo_de_combustible=El%C3%A9ctrico&filter.p.m.custom.vision_de_fuego=3+caras+en+forma+de+U'
  };
  
  // Obtener la ruta actual 
  const currentPath = window.location.pathname;
  
  // Verificar si la ruta actual necesita ser redireccionada
  if (redirects[currentPath]) {
    const targetUrl = redirects[currentPath];
    
    // Usar replace en lugar de href para que sea más rápido y no quede en el historial
    window.location.replace(targetUrl);
  }
})();
